


































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Field, Dialog } from "vant";
import { verifyTradePassword } from "@/utils/verify";
import { goBack } from "@/utils/hybirdMethods";
import customField from "@/components/customField/index.vue";
import navButtons from "@/views/app-pages/components/navButtons.vue";

@Component({
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    customField,
    navButtons
  }
})
export default class Login extends Vue {
  form = {
    password: "",
    repeat_password: "",
	account_type:""
  };

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isDisabledSubmit() {
    return Object.keys(this.form).some(key => {
      return !this.form['password'] || !this.form['repeat_password'];
    });
  }

  handleSubmit() {
	this.form.account_type = (this as any).$route.query.account_type
    if (!verifyTradePassword(this.form.password)) {
      return this.$toast.fail(
        this.$t(
          "security_center.trade_password_reset.trade_password_verify_fail_text"
        )
      );
    }
    if (this.form.repeat_password !== this.form.password) {
      return this.$toast.fail(
        this.$t(
          "security_center.trade_password_reset.trade_password_repeat_fail_text"
        )
      );
    }
    (this as any).$apis
      .resetTradePassword(this.form)
      .then(() => {
        // this.$router.push("/electronic-sign");
        (this as any).form = {
          password: "",
          repeat_password: ""
        };
        // this.$toast("操作成功");
        Dialog.alert({
          ["message" as any]: this.$t(
            "security_center.trade_password_reset.trade_password_reset_success_text"
          ),
          ["confirmButtonText" as any]: this.$t("common.complete"),
          ["className" as any]: this.bgColor ? 'black-theme-dialog' : ''
        }).then(() => {
          goBack();
        });
      })
      .catch(e => {
        
      });
  }
}
